<template>
  <div>
    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>
        <b-col cols="12" class="d-flex mb-1">
          <feather-icon icon="UserIcon" size="19" />
          <h4 class="mb-0 ml-50">
            ข้อมูลสินค้า
          </h4>
        </b-col>
        <b-col cols="12">
          <b-form-group label="รหัสสินค้า" label-for="slug">
            <b-form-input id="slug" v-model="product.slug" disabled />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="บาร์โค้ดสินค้า" label-for="barcode">
            <b-form-input id="barcode" v-model="product.barcode" disabled />
          </b-form-group>
        </b-col>

        <!-- Field: Full Name -->
        <b-col cols="12">
          <b-form-group label="ชื่อสินค้า" label-for="full-name">
            <b-form-input id="full-name" v-model="product.name" disabled />
          </b-form-group>
        </b-col>

        <!-- Field: Status -->
        <b-col cols="12">
          <b-form-group>
            <label for="textarea-default">รายละเอียดสินค้า</label>
            <b-form-textarea
              id="textarea-default"
              placeholder="Textarea"
              rows="3"
              v-model="product.description"
              disabled
            />
          </b-form-group>
        </b-col>

        <!-- Field: Email -->
        <b-col cols="12">
          <b-form-group label="ราคาสินค้า" label-for="email">
            <b-form-input
              id="email"
              type="email"
              v-model="product.price"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
import useUsersList from "../products-list/useProductsList";
export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { resolveUserRoleVariant } = useUsersList();

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const permissionsData = [
      {
        module: "Admin",
        read: true,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "Staff",
        read: false,
        write: true,
        create: false,
        delete: false,
      },
      {
        module: "Author",
        read: true,
        write: false,
        create: true,
        delete: false,
      },
      {
        module: "Contributor",
        read: false,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "User",
        read: false,
        write: false,
        create: false,
        delete: true,
      },
    ];

    const languageOptions = [
      "English",
      "Spanish",
      "French",
      "Russian",
      "German",
      "Arabic",
      "Sanskrit",
    ];

    const genderOptions = [
      { text: "ชาย", value: "male" },
      { text: "หญิง", value: "female" },
    ];

    const contactOptionsOptions = ["Email", "Message", "Phone"];

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        // eslint-disable-next-line no-param-reassign
        // props.userData.avatar = base64;
      }
    );

    return {
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      statusOptions,
      permissionsData,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      languageOptions,
      genderOptions,
      contactOptionsOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
